// extracted by mini-css-extract-plugin
module.exports = {"container":"container___3tMS3","title":"title___1Wr_R","platforms":"platforms___27-_C"};